import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class ProductCardForm extends FormBase {
    public getListImageZoomToggle(root: ParentNode = document): HTMLInputElement | null {
        return this.queryElement(root, `[data-role="${Roles.PRODUCT_LIST_IMAGE_ZOOM_TOGGLE}"]`, HTMLInputElement);
    }

    public getListingCards(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.PRODUCT_CARD}"]`, HTMLElement);
    }

    public hasProductCardOrLikeButton(root: ParentNode = document): boolean {
        return (
            this.queryElement(
                root,
                `[data-role="${Roles.PRODUCT_CARD}"], [data-role="${Roles.PRODUCT_LIKE_BTN}"]`,
                HTMLElement,
            ) instanceof HTMLElement
        );
    }

    public getTruncationTargets(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.PRODUCT_CARD_TRUNCATE}"]`, HTMLElement);
    }
}

const productCardForm = new ProductCardForm();

export { productCardForm };
